import { TextField } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-premium';
import React from 'react';

interface ScoreCellProps {
	id: GridRowId;
	value: number;
	onScoreChange: (index: number, value: number) => void;
	scoreMax?: number;
}

export const ScoreCell = ({
	id,
	value,
	onScoreChange,
	scoreMax,
}: ScoreCellProps) => {
	return (
		<TextField
			data-cy={`score-${id}`}
			style={{ width: '100%' }}
			value={value}
			onChange={(e: { target: { value: string } }) => {
				let newValue = +e.target.value;
				if (newValue !== value) {
					if (newValue < 0) newValue = 0;
					else if (scoreMax && newValue > scoreMax)
						newValue = scoreMax;
					onScoreChange(+id, newValue);
				}
			}}
			onBlur={(e: { target: { value: string } }) => {
				let newValue = +e.target.value;
				if (newValue !== value) {
					if (newValue < 0) newValue = 0;
					else if (scoreMax && newValue > scoreMax)
						newValue = scoreMax;
					onScoreChange(+id, newValue);
				}
			}}
			inputProps={{
				step: 1,
				min: 0,
				max: scoreMax,
			}}
			variant="outlined"
			type="number"
			size="small"
		/>
	);
};
